import { createSlice, PayloadAction } from "@reduxjs/toolkit"

// Define a type for the slice state
interface MenuState {
  isMobileOpen: boolean
  isCartOpen: boolean
  isContactOpen: boolean
}

// Define the initial state using that type
const initialState: MenuState = {
  isMobileOpen: false,
  isCartOpen: false,
  isContactOpen: false,
}

export const counterSlice = createSlice({
  name: "menus",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    toggleMobile: state => {
      state.isMobileOpen = !state.isMobileOpen
    },
    setCartOpen: (state, { payload }) => {
      state.isCartOpen = payload
    },
    setContactOpen: (state, { payload }) => {
      state.isContactOpen = payload
    },
  },
})

export const {
  toggleMobile,
  setCartOpen,
  setContactOpen,
} = counterSlice.actions

export default counterSlice.reducer
